(function ($, Drupal, window, document) {

  'use strict';

  Drupal.behaviors.Menu = {
    attach: function (context, settings) {
      $(once('menu','.region-header .menu--main')).superfish({
        disableHI:   true,
      });
    }
  };

  Drupal.behaviors.mobileMenu = {
    attach: function (context, settings) {
      var $mobile_menu_toggle = $('.block-dms-theming-mobile-menu-toggle');
      if (!$mobile_menu_toggle.hasClass('js-mobile-menu-toggle-init')) {
        $mobile_menu_toggle.addClass('js-mobile-menu-toggle-init').on('click', function() {
          $('body').toggleClass('mobile-menu-active');
        });
      }
      var $mobile_menu_close = $('.region-mobile-menu__close');
      if (!$mobile_menu_close.hasClass('js-mobile-menu-toggle-init')) {
        $mobile_menu_close.addClass('js-mobile-menu-toggle-init').on('click', function() {
          $('body').removeClass('mobile-menu-active');
        });
      }
    }
  };

  Drupal.behaviors.mobileMenuUnfold = {
    attach: function (context, settings) {
      $('.region--mobile-menu .menu__item--expanded').each((i, element) => {
        var child = element.querySelector('a');
        element.style.height = child.clientHeight + 'px';
        var newClickElement = $('<span>', {
          class: 'click-element',
        });
        child.append(newClickElement.get(0));
      });

      $('.region--mobile-menu .menu__item--expanded > a').on('click', function(e) {  
        if (e.target.classList.contains("click-element")) {
          e.preventDefault();
          var listItem = e.currentTarget.parentNode;
          var link = e.currentTarget;
          var list = e.currentTarget.parentNode.querySelector('ul');
  
          var listHeight = list.clientHeight;
          var listItemNewHeight = listItem.clientHeight + listHeight;
  
          if (listItem.classList.contains('expanded')) {
            listItem.style.height = link.clientHeight + 'px';
          } else {
            listItem.style.height = listItemNewHeight + 'px';
          }
  
          listItem.classList.toggle('expanded');
        }      
      })
    }
  };

})(jQuery, Drupal, this, this.document);

